/**
 * メールアドレス文字列の検証用ユーティリティ（SES 送信前提の実用的なチェック）
 */

/**
 * 表示名付きアドレス（例: Name <user@example.com>）から検証用の addr-spec を取り出す
 * @param {string} token - ";" 区切り後の1トークン
 * @returns {string}
 */
export function extractAddrSpecForMailValidation(token) {
  const t = String(token).trim();
  const open = t.lastIndexOf("<");
  const close = t.lastIndexOf(">");
  if (open !== -1 && close > open) {
    return t.slice(open + 1, close).trim();
  }
  return t;
}

/**
 * メールアドレスとして妥当そうな形式か（SES 送信前提の実用的なチェック。ASCII ベース）
 * @param {string} addr - addr-spec 相当
 * @returns {boolean}
 */
export function isWellFormedMailAddress(addr) {
  if (addr == null || addr === "") {
    return false;
  }
  const a = String(addr).trim();
  if (a.length > 254 || /\s/.test(a) || /[\u0000-\u001f\u007f]/.test(a)) {
    return false;
  }
  const at = a.lastIndexOf("@");
  if (at < 1 || at > a.length - 2) {
    return false;
  }
  const local = a.slice(0, at);
  const domain = a.slice(at + 1);
  if (local.length > 64 || domain.length > 253) {
    return false;
  }
  if (!/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+$/.test(local) || local.startsWith(".") || local.endsWith(".") || local.includes("..")) {
    return false;
  }
  if (!/^[a-zA-Z0-9.-]+$/.test(domain) || domain.startsWith(".") || domain.endsWith(".") || domain.includes("..")) {
    return false;
  }
  if (!domain.includes(".")) {
    return false;
  }
  const labels = domain.split(".");
  if (labels.some((lb) => lb.length === 0 || lb.length > 63)) {
    return false;
  }
  return labels.every((lb) => /^[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(lb));
}
